import React from "react";
import { CSSTransition } from "react-transition-group";
import { useListManager } from "../../contexts/list.manager";
import Container from "../Container/Container";
import "./ConsultaFormContainer.css";
import { cn } from "../../lib/utils";

const ConsultaFormContainer = (props) => {
	const { lineSelected, isCard } = useListManager();
	return (
		<CSSTransition
			in={lineSelected && !isCard}
			timeout={300}
			classNames="slide"
			unmountOnExit
		>
			<div className={cn("consulta-wrapper", props.className)}>{props.children}</div>
		</CSSTransition>
	);
};

export default ConsultaFormContainer;
